import './navigation.css'

export default function Navigation () {
    return (
        <div>Navigation</div>
    )
}